export function getExplicitLogonHeaders(smtp: string): { [headerName: string]: string } {
    return {
        'X-OWA-ExplicitLogonUser': smtp,
        'X-AnchorMailbox': smtp,
    };
}
